<template>
    <b-row class="my-sm-4 ">
        <b-col sm="12">
            <div class="q-create">
                <p class="t-Items">{{ $t('quickCreate.title') }}</p>
                <div class="qc">
                    <div class="q-1">
                        <div class="I-img">
                            <img src="../../../../assets/Img/icons/rise_request.svg" alt="Master" />
                        </div>
                        <div class="s-content">
                            <p class="Items">{{ $t('quickCreate.AddItems.title') }}</p>
                            <span class="light-txt">{{ $t('quickCreate.AddItems.content') }}</span>
                        </div>
                    </div>
                    <div class="q-1">
                        <div class="I-img">
                            <img src="../../../../assets/Img/icons/check_availability.svg" alt="Master" />
                        </div>
                        <div class="s-content">
                            <p class="Items">{{ $t('quickCreate.Check.title') }}</p>
                            <span class="light-txt">{{ $t('quickCreate.Check.content') }}</span>
                        </div>
                    </div>
                </div>
                <div class="qc">
                    <div class="q-1">
                        <div class="I-img">
                            <img src="../../../../assets/Img/icons/rise_request.svg" alt="Master" />
                        </div>
                        <div class="s-content">
                            <p class="Items">{{ $t('quickCreate.request.title') }}</p>
                            <span class="light-txt">{{ $t('quickCreate.request.content') }}</span>
                        </div>
                    </div>
                    <div class="q-1">
                        <div class="I-img">
                            <img src="../../../../assets/Img/icons/rise_request.svg" alt="Master" />
                        </div>
                        <div class="s-content">
                            <p class="Items">{{ $t('quickCreate.request.title') }}</p>
                            <span class="light-txt">{{ $t('quickCreate.request.content') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({

    setup() {
        return {

        }
    }

})
</script>


<style lang="scss">
.q-create {

    background-color: #FFFFFF;
    border: #E1E1E1 solid 1px;
    border-radius: 0px;

    .t-Items {
        padding-left: 20px;
        padding-top: 20px;
        color: #999999;
        text-align: left;
    }

    .qc {

        display: flex;

        .q-1 {
            text-align: start;
            padding: 10px;
            margin: 10px;
            // height: 50px;
            width: 250px;
            border: #E1E1E1 solid 1px;
            border-radius: 15px;

            .I-img {
                border: #E1E1E1 solid 1px;
                border-radius: 50px;
                padding: 11px;
                height: 40px;
                width: 40px;
                background-color: #F7F7F7;
            }

            .s-content {
                .Items {
                    text-align: left;
                    font-weight: 700;
                    letter-spacing: 0px;
                    font-size: 13px;
                    line-height: 40px;
                }

                .I-content {
                    font-size: 12px;
                    color: #7f7f7f;
                }
            }
        }
    }

}

@media only screen and (max-width:575px) {
    .q-create .qc {
        display: block;
    }

    .q-create {
        margin-top: 15px;
        margin-bottom: 15px;
    }
}
</style>